import { Box, styled, Typography } from '@mui/material';

// TODO: move this to the components and reuse it in other places
export const SidebarContainer = styled(Box)`
  & > div:first-child {
    padding: 0 16px;
  }

  padding: 20px 0 0 0;
  height: 100vh;
`;

export const SidebarContent = styled(Box)`
  flex: 1;
  overflow-y: auto;
  height: calc(100vh - 40px);
`;

export const SectionTitle = styled(Typography)(
  () => `
  margin-left: 0.9375rem;
`,
);
